import React from 'react';

import OfferCaseStudyPage from 'containers/OfferCaseStudyPage';
import { queryCMS } from 'utils/cms/api';
import {
  getOfferTypeBySlug,
  getProjectsByCategory,
  offerCaseStudyPageQuery,
  // offersSlugQuery,
  offerTypesQuery,
} from 'utils/cms/gql';
import { ISR_TIMEOUT } from 'utils/config';

const Component = props => {
  return <OfferCaseStudyPage {...props} />;
};

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  };
}

export async function getStaticProps({ locale, query, params }) {
  const slug = query ? query.slug : params.slug;

  const offersSlugsResults = await queryCMS({
    query: getOfferTypeBySlug(slug),
  });
  const offer = offersSlugsResults.offerTYpes[0];

  const offerTypesResults = await queryCMS({
    query: offerTypesQuery(locale),
  });
  const offerCaseStudyPageResults = await queryCMS({
    query: offerCaseStudyPageQuery(locale),
  });
  const page = offerCaseStudyPageResults.offerCaseStudyPage;

  const randomCategory =
    offer.categories[Math.floor(Math.random() * offer.categories.length)];

  const projectsOfCategoryResult = await queryCMS({
    query: getProjectsByCategory(randomCategory.key),
  });

  // const projectsOfCategory = await getProjectsByCategory(randomCategory.id);
  const randomProject =
    projectsOfCategoryResult.projects[
      Math.floor(Math.random() * projectsOfCategoryResult.projects.length)
    ];

  return {
    props: {
      offerTypes: offerTypesResults.offerTYpes,
      offer,
      caseStudy: randomProject,
      navItems: page.navLinks,
      footerLinkPrev: page.footerLinkPrev,
      footerLinkNext: page.footerLinkNext,
      ogTags: offer.ogTags,
    },
    revalidate: ISR_TIMEOUT,
  };
}

export default Component;
